import React, { useState } from 'react';
import api from './../../api/axios';

export default function IntegrationManagementPanel({ item, management, onChanged }) {
  const [busy, setBusy] = useState(false);
  if (!item?.providerKey || !['salesforce', 'dynamics', 'hubspot'].includes(item.providerKey) || !management) return null;
  const policy = management.providers?.[item.providerKey] || { mode: 'personal', recommendedMode: 'personal' };
  const isAdmin = management.isAdmin === true;
  const organizationManaged = policy.mode === 'organization';

  const changeMode = async (mode) => {
    setBusy(true);
    try {
      await api.patch(`/integrations/config/management/${item.providerKey}`, { mode });
      await onChanged?.();
    } finally { setBusy(false); }
  };

  return (
    <section className={`rounded-2xl border p-5 shadow-sm ${organizationManaged ? 'border-indigo-200 bg-indigo-50/50' : 'border-gray-200 bg-white'}`}>
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="max-w-2xl">
          <div className="flex flex-wrap items-center gap-2">
            <h3 className="text-sm font-semibold text-gray-950">Connection ownership</h3>
            <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset ${organizationManaged ? 'bg-indigo-100 text-indigo-700 ring-indigo-200' : 'bg-gray-100 text-gray-700 ring-gray-200'}`}>{organizationManaged ? 'Organization managed' : 'Personal connection'}</span>
            {policy.recommendedMode === 'organization' && !organizationManaged && <span className="rounded-full bg-amber-50 px-2.5 py-1 text-xs font-medium text-amber-700 ring-1 ring-amber-200">Organization mode recommended</span>}
          </div>
          <p className="mt-2 text-sm leading-6 text-gray-600">
            {organizationManaged
              ? `One admin-controlled ${item.name} connection is shared by authorized Leadgenflow members. Members do not need to authenticate separately.`
              : `Each Leadgenflow user connects their own ${item.name} account. This is useful for smaller teams or user-specific CRM access.`}
          </p>
          {organizationManaged && <div className="mt-3 text-xs text-indigo-700"><i className="fas fa-shield-halved mr-1.5" />Managed by your organization{policy.connectedByEmail ? ` · connected by ${policy.connectedByEmail}` : ' · an admin still needs to connect the CRM'}</div>}
        </div>
        {isAdmin ? (
          <div className="inline-flex rounded-xl border border-gray-200 bg-white p-1 shadow-sm">
            <button disabled={busy} onClick={() => changeMode('personal')} className={`rounded-lg px-3 py-2 text-sm font-medium ${!organizationManaged ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-50'}`}>Personal</button>
            <button disabled={busy} onClick={() => changeMode('organization')} className={`rounded-lg px-3 py-2 text-sm font-medium ${organizationManaged ? 'bg-indigo-600 text-white' : 'text-gray-600 hover:bg-gray-50'}`}>Organization managed</button>
          </div>
        ) : (
          <div className="rounded-lg bg-white/80 px-3 py-2 text-xs text-gray-600 ring-1 ring-gray-200"><i className="fas fa-lock mr-1.5" />Only an organization admin can change this setting.</div>
        )}
      </div>
    </section>
  );
}
